import { render, staticRenderFns } from "./UsuariosInactivos.vue?vue&type=template&id=efeadae0&scoped=true"
import script from "./UsuariosInactivos.vue?vue&type=script&lang=js"
export * from "./UsuariosInactivos.vue?vue&type=script&lang=js"
import style0 from "./UsuariosInactivos.vue?vue&type=style&index=0&id=efeadae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efeadae0",
  null
  
)

export default component.exports